/**
 * Created on 10/10/2015.
 */
angular.module('backend', [
  'common',
  'navigation'
]);
